export const getCancelPublicBetaNoticeStatus = (): string => {
    return localStorage.getItem('cancelPublicBetaNoticeStatus') || 'true';
};

export const setCancelPublicBetaNoticeStatus = (status: string) => {
    localStorage.setItem('cancelPublicBetaNoticeStatus', status);
};
